import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a93c86d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card__menu-item--add-to-queue-block" }
const _hoisted_2 = { class: "task-card__menu-item--add-to-queue" }

import {
  PopoverPositionEnum,
  TirPmContextMenuButton,
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPopover,
  TirPmRouterLink,
  TirPmScrollbar,
} from 'tir-components';
import { ChevronRightIcon, UserCircleIcon } from 'tir-style-system/icons/outline';
import { computed, onMounted, ref } from 'vue';
import GetPerformersTaskRequest from '../models/GetPerformersTaskRequestModel';
import { TaskKanbanAdapterService } from '../adapter';
import { TaskModel, TaskPersonModel } from '../models';
import GetPerformersTaskResponse from '../models/GetPerformersTaskResponseModel';
import { AddTaskZmkForUserRequest } from '@/pages/tasks-order-pages/models';
import { RouterLink, useRouter } from 'vue-router';
import GetPerformersTaskItem from '../models/GetPerformersTaskItem';
import { CurrentUser } from 'tir-pm-user-core';

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformerListByOrder',
  props: {
  taskInfo: { type: TaskModel, required: true },
},
  emits: ["closePopover"],
  setup(__props, { emit }) {

const props = __props;

const adapter = new TaskKanbanAdapterService();
/**Роутер */
const router = useRouter();

/**Параметры */

/**События */


/**Список исполнителей очередности */
const performersListQueue = ref<GetPerformersTaskResponse>();

/**Кол-во исполнителей */
const allUsersInQueue = computed(
  () => performersListQueue.value?.Users?.every((user) => user.InQueue) ?? false,
);

/**После рендера компонента */
onMounted(async () => {
  await getPerformersTask();
});

/**Получить список исполниетелей по задаче(с проверкой на доступ к очереди) */
const getPerformersTask = async () => {
  const resp = await adapter.getPerformersTaskAsync(
    new GetPerformersTaskRequest({
      TaskId: props.taskInfo.Id,
      ShowUsersWithAccessToQueue: true,
    }),
  );
  if (resp.IsSuccess) {
    performersListQueue.value = resp.Value;
  }
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Добавить в очередность */
const addTaskQueue = async (_userInfo: GetPerformersTaskItem) => {
  if (_userInfo.InQueue) return;
  const resp = await adapter.addTaskZmkForUserAsync(
    new AddTaskZmkForUserRequest({
      TaskId: props.taskInfo.Id,
      UserId: _userInfo.OwnerId,
    }),
  );
  if (resp.IsSuccess) {
    addNotification(`Тикет #${props.taskInfo.Id} добавлен в очередность сотрудника`);
    await getPerformersTask();
    emit('closePopover');
  }
};
/**Маршрут для перехода */
const computedRoute = (_userInfo: GetPerformersTaskItem) => {
  if (_userInfo.InQueue) return {};

  const isCurrentUserInList = CurrentUser.Id === _userInfo.OwnerId;

  return isCurrentUserInList
    ? { name: 'tasks-overview' }
    : { name: 'team-tasks', query: { userId: _userInfo.OwnerId } };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    class: "task-card__popover-performers",
    isNoTeleport: "",
    position: _unref(PopoverPositionEnum).Right
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(TirPmScrollbar), {
        showOnHover: "",
        class: "task-card__scrollbar"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(performersListQueue.value.Users, (item) => {
            return (_openBlock(), _createBlock(_unref(TirPmRouterLink), {
              key: item.OwnerId,
              class: _normalizeClass(["performer-item", {
            'performers-disabled': item.InQueue,
          }]),
              isDisabled: item.InQueue,
              to: computedRoute(item),
              target: item.InQueue ? undefined : '_blank',
              onClick: ($event: any) => (addTaskQueue(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TirPmIconView), {
                  size: 24,
                  isRounded: "",
                  colorCode: item.AvatarColor,
                  isBordered: false,
                  imageLoadUrl: item.Photo
                }, {
                  mainSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.FirstName[0] + item.LastName[0]), 1)
                  ]),
                  _: 2
                }, 1032, ["colorCode", "imageLoadUrl"]),
                _createTextVNode(" " + _toDisplayString(item.FirstName) + " " + _toDisplayString(item.LastName) + " " + _toDisplayString(item.MiddleName), 1)
              ]),
              _: 2
            }, 1032, ["isDisabled", "class", "to", "target", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TirPmContextMenuButton), { class: "task-card__menu-item-performers" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(UserCircleIcon), { class: "menu-icon" }),
              _createTextVNode(" Добавить в очередность сотрудника ")
            ]),
            _createVNode(_unref(ChevronRightIcon), { class: "menu-icon" })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["position"]))
}
}

})